import "./MoneyCreditManagementPage.css";

import React, { useEffect, useState } from "react";

import AddMoneyPopup from "Components/Popup/AddMoneyPopup/AddMoneyPopup";
import Headers from "Components/Header/Headers";
import Navigation from "Components/SideNavBar/Navigation";
import RenderInformationPopup from "Components/Popup/InformationPopup/PureComponents/InformationPopup";
import StripeOnboardingRequiredPopup from "Components/Popup/StripeOnboardingRequiredPopup/StripeOnboardingRequiredPopup";
import useStripeOnboardingGuard from "Hooks/useStripeOnboardingGuard";
import dollarIcon from "Media/icons/cards-with-dollar-sign@2x.png";
import lifeSaverIcon from "Media/icons/lifesaver@2x.png";
import moneyBack from "Media/icons/moneyBack.png";
import moneyIcon from "Media/icons/money@2x.png";
import plusIcon from "Media/icons/plus (1)@2x.png";
import renewIcon from "Media/icons/renew@2x.png";
import { toast } from "react-toastify";
import tradeIcon from "Media/icons/trade@2x.png";
import useIsAmniusOrganization from "Hooks/useIsAmniusOrganization";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import userIcon from "Media/icons/user (1)@2x.png";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import WalletTopUpModal from "Components/Popup/WalletTopUpModal/WalletTopUpModal";
import WalletPayoutModal from "Components/Popup/WalletPayoutModal/WalletPayoutModal";
import { getClientCreditBalance } from "Config/API/get";
import { fetchStripeConnectedAccountId } from "Helper/stripeConnectedAccount";
import {
  getStripeCreditBalanceAction,
  getUsableCreditBalanceAction,
} from "Redux/action/get.action";
const MoneyCreditManagementPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isOrgAmnius = useIsAmniusOrganization();
  const [addCreditPopup, setAddCreditPopup] = useState(false);
  const [showWalletTopup, setShowWalletTopup] = useState(false);
  const [showWalletPayout, setShowWalletPayout] = useState(false);
  const [showStripeOnboardingPopup, setShowStripeOnboardingPopup] =
    useState(false);
  const [infoPopup, setInfoPopup] = useState(false);
  const [tabsText, setTabsText] = useState("");
  const { isOnboardingRequired } = useStripeOnboardingGuard();
  const credit = useSelector((state) => state.getStripeCreditBalanceReducer);
    const dashboardurl = useSelector((state) => state.getUsableCrediturlReducer);

  const loggedInUserDetails = useSelector(
    (state) => state.authenticationReducer
  );
  const canTopUpWallet = loggedInUserDetails?.add_credit_rights === "manager";
  const canPayout = loggedInUserDetails?.credit_account_manager === "manager";
  const canManageStripe =
    loggedInUserDetails?.credit_account_manager === "manager";
  const generalInfo = useSelector((state) => state.renderGeneralInfo);
  const token = localStorage.getItem("token");
  const [stripeAccountId, setStripeAccountId] = useState(null);
  const hasStripeConnectedId = Boolean(stripeAccountId);
  const hasStripeDashboardUrl = Boolean(
    dashboardurl && String(dashboardurl).trim()
  );
  const canUseWalletActions = hasStripeConnectedId && hasStripeDashboardUrl;

  useEffect(() => {
    let cancelled = false;
    fetchStripeConnectedAccountId(token, loggedInUserDetails, generalInfo).then(
      (accountId) => {
        if (!cancelled) setStripeAccountId(accountId);
      }
    );
    return () => {
      cancelled = true;
    };
  }, [token, loggedInUserDetails, generalInfo]);

  const refreshCreditBalance = async () => {
    const accountId =
      stripeAccountId ||
      (await fetchStripeConnectedAccountId(
        token,
        loggedInUserDetails,
        generalInfo
      ));
    if (!accountId) return;

    const response = await getClientCreditBalance(token, accountId);
    if (response?.data?.status) {
      const creditData = response?.data?.data?.[0] || {};
      dispatch(getStripeCreditBalanceAction(creditData?.amount));
      dispatch(getUsableCreditBalanceAction(creditData?.usableAmount));
    }
  };

  return (
    <>
      <div className="mc-management-main">
        <div className="mc-management-header">
          <Headers />
        </div>

        <div className="mc-management-navigation">
          <Navigation />
        </div>

        <div className="mc-management-wrapper">
          <div className="mc-management-heading">
            Money Management Page
          </div>
          <div className="mc-management-content">
          <div
            className="mc-management-tile mc-management-wallet-tile"
            // onClick={() => window.open(dashboardurl, "_blank")}
          >
              <img
                className="mc-management-wallet-tile__icon"
                src={dollarIcon}
                alt="Wallet"
              />
              <div className="mc-management-wallet-tile__body">
                <span className="mc-management-wallet-tile__title">
                  Stripe Wallet Available Balance
                </span>
                <span className="mc-management-wallet-tile__balance">
                  {credit ? credit : 0}
                </span>
                {(canTopUpWallet || canPayout || canManageStripe) && (
                  <div className="mc-management-wallet-tile__actions">
                    {canTopUpWallet && (
                      <button
                        type="button"
                        className="rates-and-subscription-lower-tile-button mc-management-wallet-tile__button"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (isOnboardingRequired) {
                            toast(
                              "Complete Stripe onboarding before topping up your wallet.",
                              { type: "info" }
                            );
                            setShowStripeOnboardingPopup(true);
                            return;
                          }
                          if (!canUseWalletActions) return;
                          setShowWalletTopup(true);
                        }}
                      >
                        Top Up Wallet
                      </button>
                    )}
                    {canPayout && (
                      <button
                        type="button"
                        className="rates-and-subscription-lower-tile-button mc-management-wallet-tile__button"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (isOnboardingRequired) {
                            toast(
                              "Complete Stripe onboarding before requesting a payout.",
                              { type: "info" }
                            );
                            setShowStripeOnboardingPopup(true);
                            return;
                          }
                          if (!canUseWalletActions) return;
                          setShowWalletPayout(true);
                        }}
                      >
                        Payout
                      </button>
                    )}
                    {canManageStripe && hasStripeDashboardUrl && (
                      <button
                        type="button"
                        className="rates-and-subscription-lower-tile-button mc-management-wallet-tile__button mc-management-wallet-tile__button--secondary"
                        onClick={(e) => {
                          e.stopPropagation();
                          window.open(dashboardurl, "_blank");
                        }}
                      >
                        Manage Stripe Account
                      </button>
                    )}
                  </div>
                )}
              </div>
              <QuestionMarkIcon
                className="moneyCreditManagement-info"
                onClick={(e) => {
                  e.stopPropagation();
                  setInfoPopup(true);
                  setTabsText("CURRENT CREDITS");
                }}
              />
            </div>
            <div
              className="mc-management-tile"
              onClick={() => navigate("/rates-and-subscription-management")}
            >
              <img
                className="mc-management-tile__icon"
                src={renewIcon}
                alt="Rates and Subscription"
              />
              <span className="mc-management-tile__label">Rates & Subscription</span>
              <QuestionMarkIcon
                className="moneyCreditManagement-info"
                onClick={(e) => {
                  e.stopPropagation();
                  setInfoPopup(true);
                  setTabsText("Rates & Subscription");
                }}
              />
            </div>
            {!isOrgAmnius && (
               <div className="mc-management-tile" style={{      height: "155px", }}   onClick={() => {
                  if (loggedInUserDetails?.credit_read_rights === "manager")
                    return navigate("/all-refund-requests");
                  toast("You do not have rights to view refund requests", {
                    type: "info",
                  });
                }}>
              <img
                  src={moneyBack}
                  alt="Wallet"
                  style={{ width: "65px", height: "65px" }}
                />

                <span>Refund Requests</span>
             <QuestionMarkIcon
                className="transfer-and-banking-info"
                onClick={() => {
                  setInfoPopup(true);
                  setTabsText("Refund Requests");
                }}
              />
            </div>
            
            )}
            <div className="mc-management-tile">
              <div
                className="moneyCredit-management-tile"
                style={{
                  height: "155px",
                }}
                onClick={() =>
                  navigate("/service-ticket-user-management", {
                    state: { tab: "creditHandling" },
                  })
                }
              >
                <img
                  src={userIcon}
                  alt="Wallet"
                  style={{ width: "65px", height: "65px" }}
                />
                <span>User Management</span>
              </div>
              <QuestionMarkIcon
                className="moneyCreditManagement-info"
                onClick={() => {
                  setInfoPopup(true);
                  setTabsText("User Management");
                }}
              />
            </div>
            <div className="mc-management-tile">
              <div
                className="moneyCredit-management-tile"
                style={{
                  height: "155px",
                }}
                onClick={() => {
                  if (loggedInUserDetails?.credit_read_rights === "manager")
                    return navigate("/money-credit-transaction-activity");
                  toast(
                    "You do not have rights to view transaction activities",
                    {
                      type: "info",
                    }
                  );
                }}
              >
                <img
                  src={tradeIcon}
                  alt="Wallet"
                  style={{ width: "65px", height: "65px" }}
                />
                <span>Transaction Activity</span>
              </div>
              <QuestionMarkIcon
                className="moneyCreditManagement-info"
                onClick={() => {
                  setInfoPopup(true);
                  setTabsText("Transaction Activity");
                }}
              />
            </div>
            {!isOrgAmnius && (
              <div className="mc-management-tile">
                <div
                  className="moneyCredit-management-tile"
                  style={{
                    height: "155px",
                  }}
                  onClick={() => {
                    navigate("/contact-support");
                  }}
                >
                  <img
                    src={lifeSaverIcon}
                    alt="Wallet"
                    style={{
                      width: "65px",
                      height: "65px",
                      marginRight: "20px",
                    }}
                  />

                  <span>Contact Support</span>
                </div>
                <QuestionMarkIcon
                  className="moneyCreditManagement-info"
                  onClick={() => {
                    setInfoPopup(true);
                    setTabsText("Contact Support");
                  }}
                />
              </div>
            )}
          </div>
          
          {isOrgAmnius && (
            <div
              className="mc-management-lower-tile"
              onClick={() => navigate("/all-refund-requests")}
            >
              <img
                src={moneyBack}
                alt="Wallet"
                style={{ width: "65px", height: "65px" }}
              />
              <span>Refund Requests</span>
            </div>
          )}
        </div>
      </div>

      {addCreditPopup ? <AddMoneyPopup hide={setAddCreditPopup} /> : null}
      {infoPopup ? (
        <RenderInformationPopup message={tabsText} hide={setInfoPopup} />
      ) : null}
      {showWalletTopup && canTopUpWallet && (
        <WalletTopUpModal
          hide={setShowWalletTopup}
          token={token}
          dashboardUrl={dashboardurl}
          onSuccess={async () => {
            await refreshCreditBalance();
            setShowWalletTopup(false);
          }}
        />
      )}
      {showWalletPayout && canPayout && (
        <WalletPayoutModal
          hide={setShowWalletPayout}
          token={token}
          accountId={stripeAccountId}
          onSuccess={refreshCreditBalance}
        />
      )}
      {showStripeOnboardingPopup && (
        <StripeOnboardingRequiredPopup
          hide={setShowStripeOnboardingPopup}
          dashboardUrl={dashboardurl}
        />
      )}
    </>
  );
};

export default MoneyCreditManagementPage;
